import { render, staticRenderFns } from "./noticePage.vue?vue&type=template&id=fd6e5b4c&scoped=true&"
import script from "./noticePage.vue?vue&type=script&lang=js&"
export * from "./noticePage.vue?vue&type=script&lang=js&"
import style0 from "./noticePage.vue?vue&type=style&index=0&id=fd6e5b4c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd6e5b4c",
  null
  
)

export default component.exports